import { FaLinkedin,FaInstagram,FaGithub } from "react-icons/fa";
import { IoIosCloudDownload } from "react-icons/io";
import { FaFileDownload } from "react-icons/fa";

// Replace 'YOUR_FILE_ID' with your actual Google Drive file ID
const RESUME_URL = "https://drive.google.com/uc?export=download&id=YOUR_FILE_ID";

const Footer = ()=>{
    return (
    <div className="flex flex-col gap-4 sm:flex-row items-center justify-center sm:justify-between sm:mx-20 border-t-2 border-t-white/20 m-2 p-3">
        
        <div className="flex flex-col gap-4 mt-5 items-center justify-center">
            <h2 className="text-2xl font-bold">Tulasidhar Mulakaluri</h2>

            <p className="px-12 sm:px-2 py-2">
                ** This portfolio is built completely without the use of AI ** <br/>
                Thank you for giving your time to look my portfolio.
            </p>
            <a href={RESUME_URL} className="flex items-center gap-3 text-white hover:bg-white/70 p-2 rounded-sm hover:text-black m-auto">
                <FaFileDownload/>
                Download resume
            </a>

        </div>
        
        <div>
            <h2 className="text-xl font-bold mb-2">Let's stay in touch</h2>
            
            <div className="flex gap-2 text-3xl justify-center">
                <a href="https://www.linkedin.com/in/tulasidhar" target="_blank">
                    <FaLinkedin className="hover:text-blue-600"/>
                </a>
                
                <a href="https://www.instagram.com/dasu2k" target="_blank">
                    <FaInstagram className="hover:text-red-500"/>
                </a>

                <a href="https://github.com/TulasidharM" target="_blank">
                    <FaGithub className="hover:text-violet-700"/>
                </a>
            </div>
        </div>
    
    </div>
    ) 
}


export default Footer;